<div [class.invisible]="!showZoomButtons" id="toolbarViewerMiddle">
  <pdf-zoom-out></pdf-zoom-out>
  <pdf-zoom-in></pdf-zoom-in>
  <pdf-zoom-dropdown
      style="width: unset; max-width: unset;padding-top:3px" [zoomLevels]="zoomLevels">
  </pdf-zoom-dropdown>
</div>
